import React, { Component } from "react";
import { connect } from "react-redux";
import { getMyCards, removeCard } from "../../../action_managers/subscriptions";
import Spinner from "../../lib/spinner";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import "./payment-method.scss";
import ContextMenu from "../../lib/context_menu";
import moment from "moment";
import { showModal } from "../../../actions/modal";
import { CONFIRMATION_MODAL } from "../../modals/modal_root";

class PaymentMethods extends Component {
  componentDidMount() {
    this.props.getMyCards();
  }

  getCards = () => {
    return get(this.props.payments, "cards");
  };

  renderCards = () => {
    if (isEmpty(this.getCards())) {
      return null;
    }

    return Object.keys(this.getCards()).map(key => {
      const card = this.getCards()[key];
      return (
        <div className={"payment-methods-row"} key={card.id}>
          <h4 className={"card-name bold"}>{card.brand}</h4>
          <div className={"last-4 bold"}>**** **** **** {card.last4}</div>
          <div className="exp bold">
            {moment()
              /* moment months are zero indexed */
              .month(card.exp_month - 1)
              .year(card.exp_year)
              .format("MM/YY")}
          </div>
          <div className="flex-1" />
          <ContextMenu
            menuItems={{
              "Remove Card": () => {
                this.removeCard(card.id);
              },
            }}
          />
        </div>
      );
    });
  };

  removeCard = cardID => {
    this.props.removeCardModal(cardID, () => {
      return this.props.removeCard(cardID).then(() => {
        return this.props.getMyCards();
      });
    });
  };

  render() {
    if (this.props.payments.isLoading) {
      return (
        <div className="position-relative payment-methods__spinner-container">
          <Spinner isLoading={true} />;
        </div>
      );
    }
    return (
      <div className={"payment-methods"}>
        <h2>Payment Methods</h2>
        {this.renderCards()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { payments: state.payments };
}

export default connect(mapStateToProps, {
  getMyCards,
  removeCard,
  removeCardModal: (cardID, callback) => {
    return showModal(CONFIRMATION_MODAL, {
      modalTitle: "Remove Card",
      confirmationMessage: "You can add this card again later by editing a subscription",
      callback,
      actionButtonName: "Remove Card",
    });
  },
})(PaymentMethods);
